if (!customElements.get('azafran-bundle-selector')) {
  const AZAFRAN_BUNDLE_OFFERS = {
    'ritual-light': [55130832634241],
    'ritual-golden': [55130832634241, 55132781838721],
    'ritual-complete': [55130832634241, 55132781838721, 55132784820609, 55132786229633],
    'winter-60': [55040138903937],
    'winter-120': [55040138903937],
    'winter-complete': [55040138903937, 54825626304897, 55069660774785],
  };
  // WideBundle's automatic discount is global, even when its theme embed is disabled.
  // Change this marker to "v2-lines" only as part of the coordinated WideBundle cutover.
  const AZAFRAN_BUNDLE_ENGINE = 'v2-coexistence';

  customElements.define(
    'azafran-bundle-selector',
    class AzafranBundleSelector extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector('.azafran-bundle__submit');
        this.errorMessage = this.querySelector('.azafran-bundle__error');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton?.addEventListener('click', this.addSelectedOffer.bind(this));

        if (this.cart) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
      }

      async addSelectedOffer() {
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected) {
          this.showError('Selecciona una oferta para continuar.');
          return;
        }

        const components = AZAFRAN_BUNDLE_OFFERS[selected.value];
        if (!components) {
          this.showError('La oferta seleccionada no est\u00e1 disponible. Recarga la p\u00e1gina e int\u00e9ntalo de nuevo.');
          return;
        }

        this.showError();
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute('aria-busy', 'true');

        const bundleId = this.createBundleId();
        const payload = {
          // Shopify prepends batch additions, so reverse the request to preserve the
          // customer-facing component order used by WideBundle in the cart drawer.
          items: components.slice().reverse().map((variantId) => ({
            id: variantId,
            quantity: 1,
            properties: {
              _azafran_bundle_engine: AZAFRAN_BUNDLE_ENGINE,
              _azafran_bundle_offer: selected.value,
              _azafran_bundle_id: bundleId,
            },
          })),
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement?.(this.submitButton);
        }

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(
              result.description ||
                result.message ||
                'Alguno de los productos de esta oferta no está disponible temporalmente.'
            );
          }

          if (this.cart) {
            this.cart.classList.remove('is-empty');
            this.cart.renderContents(result);
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        } catch (error) {
          console.error('Azafrán bundle:', error);
          this.showError(
            error.message ||
              'Alguno de los productos de esta oferta no está disponible temporalmente.'
          );
        } finally {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.removeAttribute('aria-busy');
        }
      }

      showError(message = '') {
        if (!this.errorMessage) return;
        this.errorMessage.hidden = !message;
        this.errorMessage.textContent = message;
      }

      createBundleId() {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
        return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      }
    }
  );
}
